import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit-active",
  "use": "icon-edit-active-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-edit-active\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"m15.595.345-8.25 8.25 1.06 1.06 8.25-8.25z\" fill=\"#236CFF\" fill-rule=\"nonzero\" /><path d=\"M16 5.415V14.5a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 1 14.5v-12A1.5 1.5 0 0 1 2.5 1h9.092\" stroke=\"#236CFF\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol